<template>
  <div class="registration-entry">
    <div style="width: 78%">
      <b>{{ registration.name }}</b>
      <p>
        Inscription pour le membre :
        <br />
        {{ registration.member.firstName }}
        {{ registration.member.lastName }}
      </p>
    </div>
    <div style="width: 100px;">
      <p style="text-align: right">{{ registration.price | money }}</p>
      <p style="text-align: right" v-if="registration.fees && registration.fees > 0">
        Frais: {{ registration.fees | money }}
      </p>
    </div>
    <a @click="removeRegistration()" style="max-width: 30px">
      <font-awesome-icon icon="times" />
    </a>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'cart-registration',
    props: {
      registration: {
        type: Object
      }
    },
    data() {
      return {
        id: null,
        type: null
      };
    },
    created() {
      if (this.registration.activity) {
        this.type = 'activity';
      }
      else if (this.registration.class) {
        this.type = 'class';
      }
      else if (this.registration.conference) {
        this.type = 'conference';
      }

      if (this.type) {
        this.id = this.registration[this.type].id;
      }
    },
    computed: {
      namedType() {
        switch (this.type) {
          case 'activity':
            return 'Activité';
          case 'class':
            return 'Cours';
          case 'conference':
            return 'Conférence';
          default:
            return 'Produit inconnu';
        }
      },
      name() {
        return this.registration[this.type].name;
      },
      description() {
        return this.registration[this.type].description.substring(0, 200) + '...';
      }
    },
    methods: {
      ...mapActions('orders', {
        _removeRegistration: 'removeRegistration'
      }),
      async removeRegistration() {
        await this._removeRegistration({
          registrationId: this.id,
          type: this.type,
          memberId: this.registration.member.id
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
.registration-entry {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-bottom: 20px;

  img {
    max-width: 50px;
  }

  &__quantity {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }
}

p {
  margin-left: 0;
  padding-left: 0;
}
</style>
